import { createContext, useContext } from "react";

// apis
import { getStoreOperatingHours } from "pages/api/storeOperatingHours";

// contexts
import MerchantContext from "@/contexts/MerchantContext";

const StoreOperatingHourContext = createContext({});

const StoreOperatingHourContextProvider = ({ children }) => {
  const merchantInfoContext = useContext(MerchantContext);
  const { landingPageData, landingPageFetchStatus } = getStoreOperatingHours(
    merchantInfoContext.merchantId
  );
  return (
    <StoreOperatingHourContext.Provider
      value={{ landingPageData, landingPageFetchStatus }}
    >
      {children}
    </StoreOperatingHourContext.Provider>
  );
};
const useStoreOperatingHour = () => {
  return useContext(StoreOperatingHourContext);
};
export {
  StoreOperatingHourContext,
  StoreOperatingHourContextProvider,
  useStoreOperatingHour,
};
